export default __webpack_public_path__ + "static/media/zawodnik4.c06b57c0.png";